"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Games = void 0;
var Games_1 = require("./Games");
Object.defineProperty(exports, "Games", { enumerable: true, get: function () { return __importDefault(Games_1).default; } });
